import { render, staticRenderFns } from "./PosBillAfter.vue?vue&type=template&id=8053d032&scoped=true&"
import script from "./PosBillAfter.vue?vue&type=script&lang=js&"
export * from "./PosBillAfter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8053d032",
  null
  
)

export default component.exports